import * as React from 'react';

import * as styles from './backdrop.less';
import { responsiveHelper } from '../../../Shared/helpers/responsive-helper';
import { classNames } from '../../../Shared/utils/classnames';

type IBackdropProps = {
	imageUrl: string;
	mobileUrl: string;
	className?: string;
};

export const Backdrop: React.FC<IBackdropProps> = ({ className = '', imageUrl, mobileUrl }) => (
	<div className={classNames(styles.container, className)}>
		<img
			src={responsiveHelper.isMd || responsiveHelper.isSm || responsiveHelper.isXs ? mobileUrl : imageUrl}
			alt="backdrop image"
			data-pp-at-target="backdrop Image"
			className={styles.image}
		/>
		<div className={styles.gradients}></div>
	</div>
);
